import { SeoMetaData } from '@cms-max/cms-browser-api-client'

export const premiumsSeoMetaData: SeoMetaData[] = [
  {
    path: '/premiums/bills',
    seo: {
      en: {
        title: 'Premium bills | Medicare',
        description: ''
      },
      es: {
        title: '',
        description: ''
      }
    }
  },
  {
    path: '/premiums/monthly',
    seo: {
      en: {
        title: 'My monthly premiums | Medicare',
        description: ''
      },
      es: {
        title: '',
        description: ''
      }
    }
  },
  {
    path: '/premiums/easy-pay/signup',
    seo: {
      en: {
        title: 'Sign up for Medicare Easy Pay | Medicare',
        description: ''
      },
      es: {
        title: '',
        description: ''
      }
    }
  },
  {
    path: '/premiums/easy-pay/signup/submitted',
    seo: {
      en: {
        title: 'Medicare Easy Pay request submitted | Medicare',
        description: ''
      },
      es: {
        title: '',
        description: ''
      }
    }
  },
  {
    path: '/premiums/easy-pay/edit',
    seo: {
      en: {
        title: 'Change Medicare Easy Pay| Medicare',
        description: ''
      },
      es: {
        title: '',
        description: ''
      }
    }
  },
  {
    path: '/premiums/easy-pay/edit/submitted',
    seo: {
      en: {
        title: 'Medicare Easy Pay change submitted | Medicare',
        description: ''
      },
      es: {
        title: '',
        description: ''
      }
    }
  },
  {
    path: '/premiums/easy-pay/stop',
    seo: {
      en: {
        title: 'Stop Medicare Easy Pay| Medicare',
        description: ''
      },
      es: {
        title: '',
        description: ''
      }
    }
  },
  {
    path: '/premiums-easy-pay/stop/success',
    seo: {
      en: {
        title: 'Medicare Easy Pay stopped | Medicare',
        description: ''
      },
      es: {
        title: '',
        description: ''
      }
    }
  }
].map(seoMetaData => ({
  component: 'Premiums',
  ...seoMetaData
}))
